@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row.balance_age_bucket) {
    <span>{{ getData($.row.balance_age_bucket) }} </span>
  } @else {
    -
  }
}
